var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"objectScndNest"},[_c('div',[_c('ReClientNeeds'),_c('ReSearchScndFlatBig',{attrs:{"objData":_vm.ApiData[0]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }